import { enqueueSnackbar } from "notistack";
import refreshTicket from "../controllers/booking/refreshTicket";
import getCityCodes from "../controllers/Flight/getCityCodes";
import axios from "axios";

export default function useFlight() {
  async function refreshBooking(id) {
    const res = await refreshTicket(id);
    if (res.return) {
      enqueueSnackbar("Refreshed", { variant: "success" });
    } else enqueueSnackbar(res.msg, { variant: "error" });

    return res;
  }

  const fetchCityCodes = async ({
    inputValue,
    cancelTokenSource,
    setLoading,
    setDestinations,
  }) => {
    if (!inputValue) return;
    let value = (inputValue?.city || inputValue)?.split(" (")[0];

    if (cancelTokenSource?.current) {
      cancelTokenSource.current.cancel("Request canceled due to new input.");
    }

    cancelTokenSource.current = axios.CancelToken.source();

    try {
      setLoading(true);
      const res = await getCityCodes(value, cancelTokenSource.current.token);

      if (res.return) {
        const data = res.data.data?.flatMap((obj) => [
          obj,
          ...(obj?.children?.map((child) => ({ ...child, sub: true })) || []),
        ]);
        if (data?.length > 0) {
          setLoading(false);
        }
        setDestinations(data || []);
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request canceled:", err.message);
      } else {
        console.error("Error fetching city codes:", err);
      }
      setLoading(false);
    }
  };

  return {
    refreshBooking,
    fetchCityCodes,
  };
}
